import runtimeEnvConfig from '../../../runtime-env.config.json';

const { runtimeEnvKeys } = runtimeEnvConfig;

type RuntimeEnvironmentKey = (typeof runtimeEnvKeys)[number];
type RuntimeEnvironmentValue = Partial<Record<RuntimeEnvironmentKey, string>>;
type BuildTimeGlobal = typeof globalThis & {
	__BUILD_TIME_RUNTIME_ENV__?: RuntimeEnvironmentValue;
};

const normalizeEnvValue = (value: string | undefined) => value || undefined;

const getRuntimeEnv = () => {
	if (typeof window !== 'undefined') {
		return window._env_;
	}
};

const getBuildTimeEnv = () => (globalThis as BuildTimeGlobal).__BUILD_TIME_RUNTIME_ENV__;

const readEnvVariable = (key: RuntimeEnvironmentKey) =>
	normalizeEnvValue(getRuntimeEnv()?.[key]) ?? normalizeEnvValue(getBuildTimeEnv()?.[key]);

const readBooleanEnvVariable = (key: RuntimeEnvironmentKey, fallback = false) =>
	(readEnvVariable(key) ?? String(fallback)).toLowerCase() === 'true';

export const getBooleanEnvVariable = readBooleanEnvVariable;
export const getEnvVariable = readEnvVariable;
export type RuntimeEnvironment = RuntimeEnvironmentValue;
